var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { usePageEntity } from '../hooks/use-page-entity';
import { EntityConversationLayout } from './entity-conversation-layout';
import { EntityConversationsLayout } from './entity-conversations-layout';
var cls = classNames('slice-conversations');
export var SliceConversationDefaultProps = {
  showBanner: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ConversationsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 70vh;\n  "], ["\n    height: 70vh;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceConversation',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Conversations: styled(EntityConversationsLayout)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ConversationsStyles),
  BannerConversations: styled(EntityConversationLayout)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ConversationsStyles)
};
export var SliceConversation = function (props) {
  var _a = useComponentProps(My.NAME, SliceConversationDefaultProps, props),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    showBanner = _a.showBanner;
  var activeEntity = usePageEntity();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, showBanner ? React.createElement(My.Conversations, {
    items: [activeEntity]
  }) : React.createElement(My.BannerConversations, {
    entity: activeEntity
  }));
};
SliceConversation.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;